import { render, staticRenderFns } from "./SendResult.vue?vue&type=template&id=388ffc13"
import script from "./SendResult.vue?vue&type=script&lang=js"
export * from "./SendResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports